import BaseSubscription from './BaseSubscription';
import services, { logInfo, logError } from './services';
import { setTotalUnreadCount } from './../actions/actions';
import { store } from './../store';
import { gql, insertGraphQLFragments } from './GraphQLClient';
import faviconUnread from '../../public/assets/images/favicon-unread.ico';
import favicon from '../../public/assets/images/favicon.ico';

export const TOTAL_UNREAD_COUNTER_CHANGE = 'TOTAL_UNREAD_COUNTER_CHANGE';

export default class TotalUnreadCounter extends BaseSubscription {

  totalUnreadCount = 0;
  currentCompany = {};

  totalUnreadCounterQuery = insertGraphQLFragments(gql`
    subscription ($companyId: Uuid!) {
      updateUnreadMessagesCount(companyId: $companyId) {
        unreadMessagesCount
      }
    }
  `);

  initialize = ({ currentCompany }) => {
    this.currentCompany = currentCompany;
    this.setCount(currentCompany.unreadMessagesCount);
    this.subscribe();
  };

  setCount = (count) => {
    if (this.totalUnreadCount !== count) {
      this.totalUnreadCount = count;
      store.dispatch(setTotalUnreadCount(count));
      this.setFavicon(count);
      this.triggerEvent(TOTAL_UNREAD_COUNTER_CHANGE, count);
    }
  };

  setFavicon = (count) => {
    const linkFaviconElement = document.querySelector('link[rel="shortcut icon"]');
    linkFaviconElement.href = Boolean(count) ? faviconUnread : favicon;
  };

  subscribe = () => {
    return services.graphQLClientSocket.subscribe({
      query: this.totalUnreadCounterQuery,
      variables: {
        companyId: this.currentCompany.id,
      },
      onAbort: error => {
        logError('TotalUnreadCounter: Failed to subscribe', { error });
      },
      onStart: () => {
        logInfo('TotalUnreadCounter: Subscribed');
      },
      onResult: response => {
        const count = response?.data?.updateUnreadMessagesCount?.unreadMessagesCount;
        if (typeof count === 'number') {
          this.setCount(count);
        }
      },
    });
  };

  unsubscribe = () => {
    logInfo('TotalUnreadCounter: Unsubscribing...');
    services.graphQLClientSocket.unsubscribe(this.totalUnreadCounterQuery);
    this.setCount(0);
  };
}
